import { axiosInstance } from '../../../api';

const base = 'api/attendance';
export const shiftApi = {
  shifts: () => axiosInstance.get(`${base}/shifts/`).then(r => r.data),
  createShift: data => axiosInstance.post(`${base}/shifts/`, data).then(r => r.data),
  addVersion: (id, data) => axiosInstance.post(`${base}/shifts/${id}/versions/`, data).then(r => r.data),
  assignments: () => axiosInstance.get(`${base}/shift-assignments/`).then(r => r.data),
  createAssignment: data => axiosInstance.post(`${base}/shift-assignments/`, data).then(r => r.data),
  groups: () => axiosInstance.get(`${base}/shift-groups/`).then(r => r.data),
  createGroup: data => axiosInstance.post(`${base}/shift-groups/`, data).then(r => r.data),
  addGroupMember: (id, data) => axiosInstance.post(`${base}/shift-groups/${id}/members/`, data).then(r => r.data),
  assignGroupShift: (id, data) => axiosInstance.post(`${base}/shift-groups/${id}/assignments/`, data).then(r => r.data),
  rosters: params => axiosInstance.get(`${base}/shift-rosters/`, { params }).then(r => r.data),
  createRoster: data => axiosInstance.post(`${base}/shift-rosters/`, data).then(r => r.data),
  saveEntries: (id, data) => axiosInstance.put(`${base}/shift-rosters/${id}/entries/`, data).then(r => r.data),
  publish: id => axiosInstance.post(`${base}/shift-rosters/${id}/publish/`).then(r => r.data),
  validateRoster: id => axiosInstance.post(`${base}/shift-rosters/${id}/validate/`).then(r => r.data),
  versions: id => axiosInstance.get(`${base}/shift-rosters/${id}/versions/`).then(r => r.data),
  shadow: data => axiosInstance.post(`${base}/policy-shadow-preview/`, data).then(r => r.data),
};
